
























































































































































































import { Component, Mixins } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import mixins from "@/mixins";
import { Colors } from "@/types";
import { MIXIN_SCHEME } from "@/constants";

@Component
class TransactionPage extends Mixins(mixins.page) {
  @Getter("wallet/mixin/getAssetById") getAssetById;

  @Getter("wallet/mixin/users/getUserById") getUserById;

  @Action("wallet/mixin/users/loadUser") loadUser;

  detail: any = {};

  loading = false;

  validType = ["transfer", "deposit", "withdrawal", "fee", "rebate"];

  get title() {
    return this.$t("wallet.transaction.title") as string;
  }

  get id() {
    return this.$route.params.id as string;
  }

  get user() {
    return this.getUserById(this.detail.opponent_id);
  }

  get name() {
    const user = this.user;
    return user
      ? user.full_name || this.detail.opponent_id
      : this.detail.opponent_id;
  }

  get asset() {
    return this.detail.asset || {};
  }

  get chainLogo() {
    return this.$common.utils.helper.getChainLogo(this, this.asset);
  }

  get walletAsset() {
    return this.getAssetById(this.asset.asset_id);
  }

  get logo() {
    return this.asset.icon_url;
  }

  get symbol() {
    return this.asset.symbol || "";
  }

  get amountText() {
    if (!this.detail.amount) {
      return "-";
    }
    const amount = this.detail.amount;
    const value = Number(amount);
    const text = value > 0 ? `+${amount}` : amount;
    return `${text}`;
  }

  get amountColor() {
    const value = Number(this.detail.amount);
    return value > 0 ? Colors.GREEN : Colors.RED;
  }

  get usdAmount() {
    if (!this.walletAsset) {
      return "-";
    }
    if (!this.detail.amount) {
      return "-";
    }
    const price = this.walletAsset.price_usd;
    const amount = this.detail.amount;
    return this.$common.utils.number.toPrecision(
      Number(price) * Number(amount),
      2
    );
  }

  get time() {
    if (!this.detail.created_at) {
      return "-";
    }
    return this.$common.utils.date.formatDate(
      this.detail.created_at,
      "YYYY/MM/DD HH:mm:ss"
    );
  }

  get snapshot() {
    const data = this.$route.query.data as any;
    if (!data) {
      return "";
    }
    return JSON.parse(decodeURIComponent(data));
  }

  get type() {
    if (!this.snapshot) {
      return "";
    }
    const type = this.snapshot.type;
    const valid = this.validType.includes(type);
    return valid
      ? this.$t(`wallet.snapshot.type.${type}`)
      : this.$t("wallet.snapshot.type.INVALID");
  }

  get hash() {
    if (!this.snapshot) {
      return "";
    }
    return this.snapshot.transaction_hash;
  }

  get traceId() {
    if (!this.snapshot) {
      return "";
    }
    return this.snapshot.trace_id;
  }

  get sender() {
    if (!this.snapshot) {
      return "";
    }
    return this.snapshot.sender;
  }

  get receiver() {
    if (!this.snapshot) {
      return "";
    }
    return this.snapshot.receiver;
  }

  get memo() {
    let memo = "-";
    if (this.detail) {
      if (this.detail.data) {
        memo = this.detail.data;
      } else {
        const assetId = this.detail?.asset?.asset_id;
        const asset = this.$store.getters["wallet/mixin/getAssetById"](assetId);
        memo = asset?.tag ?? "-";
      }
    }
    return memo;
  }

  get totalLegal() {
    if (!this.asset) {
      return "-";
    }
    const totalLegal = this.$common.utils.currency.fiat(this, {
      value: this.usdAmount,
      from: "USD"
    });
    return `≈${totalLegal}`;
  }

  async mounted() {
    this.loading = true;
    await this.requestDetail(this.id);
    await this.loadUser(this.detail.opponent_id);
    this.loading = false;
  }

  handleViewInMixin() {
    const scheme = MIXIN_SCHEME.SNAPSHOTS + `?trace=${this.detail.trace_id}`;
    window.location.href = scheme;
  }

  async requestDetail(id) {
    try {
      const detail = await this.$api.wallet.mixin.getSnapshot(id);
      this.detail = detail;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default TransactionPage;
